<template>
  <div class="change-device-dialog">
    <div>
      <h1 class="item-title">{{ $t('components_contract_change_device.he_tong_xin_xi') }}</h1>
      <div class="item-title-info">
        <el-row>
          <el-col :span="8">
            <span class="label">{{ $t('components_contract_change_device.he_tong_lei_xing') }}:</span>
            <span class="value">{{ getDicValue('crm_contract_type', detail.contractType) }}</span>
          </el-col>
          <el-col :span="8">
            <span class="label">{{ $t('components_contract_change_device.he_tong_bian_hao') }}:</span>
            <span class="value">{{ detail.contractNo }}</span>
          </el-col>
          <el-col :span="8">
            <span class="label">{{ $t('components_contract_change_device.sghth') }}:</span>
            <span class="value">{{ detail.customContractNo }}</span>
          </el-col>
          <el-col :span="8">
            <span class="label">{{ $t('components_contract_change_device.jfsqdbgs') }}:</span>
            <span class="value">{{ detail.partyAName }}</span>
          </el-col>
          <el-col :span="8">
            <span class="label">{{ $t('components_contract_change_device.yi_fang') }}:</span>
            <span class="value">{{ detail.customerName }}</span>
          </el-col>
          <el-col :span="8">
            <span class="label">{{ $t('components_contract_change_device.shou_hou_gong_si') }}:</span>
            <span class="value">{{ detail.afterServiceName }}</span>
          </el-col>
          <el-col :span="8">
            <span class="label">{{ $t('components_contract_change_device.xiang_mu_ming_cheng') }}:</span>
            <span class="value">{{ detail.locationName }}</span>
          </el-col>
          <el-col :span="16">
            <span class="label">{{ $t('components_contract_change_device.shi_yong_di_dian') }}:</span>
            <span class="value">{{detail.country || ''}}{{detail.province || ''}}{{detail.city || ''}}{{ detail.useAddress }}</span>
          </el-col>
        </el-row>
      </div>
      <h1 class="item-title">{{ $t('components_contract_change_device.sbbgxx') }}</h1>
      <div class="stop-rent-tip" v-if="lastDevice.length"><i class="icon icon-tishi"></i><span>{{$t('components_contract_change_device.ji_shen_hao')}} {{lastDevice.join(',')}}，{{ $t('components_contract_change_device.zyhtohthwdyhtzjxghsb', [lastContract]) }}</span></div>
      <div style="margin-bottom: 30px">
        <custom-table
          ref="customTb1"
          v-model="selectDevice"
          type="checkbox"
          tableCode="contractChangeDevice"
          :data="dataList"
          @filter="filterChange"
          @sort="sortChange"
          :slots="['backLocation', 'newBodyNum', 'action']"
        >
          <!-- 新机身号 -->
          <template slot="newBodyNum" slot-scope="scope">
            <el-input disabled v-model="scope.row.newBodyNum" style="width: 140px"></el-input>
            <el-button :disabled="model.type === 'watch'" size="mini" style="margin: 7px 8px 0 0" type="text" @click="onDeviceDialog(scope.row)">{{ $t('components_contract_change_device.xuan_ze_she_bei') }}</el-button>
          </template>
          <!-- 退回地点 -->
          <template slot="backLocation" slot-scope="scope">
            <custom-select
              width="96%"
              :data="orgList"
              :auto="scope.$index === 0"
              :disabled="model.type === 'watch'"
              v-model="scope.row.deviceBackOrgId"
              :placeholder="$t('components_contract_change_device.qsrshgs')"
              url="PartnerHqSc"
              :params="{ orderDeviceId: scope.row.orderDeviceId }"
              :props="{ label: 'partnerName', value: 'partnerOrgId' }"
              @change="onSelectBackOrg($event, scope.row)"
              @getList="getList"
            ></custom-select>
          </template>
          <!-- 操作 -->
          <template slot="action" slot-scope="scope">
            <el-button type="text" size="mini"  :disabled="!scope.row.newBodyNum || !scope.row.rentalStartTime || ( model.row && model.row.changeState == 10)"  @click="onPreview(scope.row)">{{ $t('components_contract_change_device.yu_lan_zhang_dan') }}</el-button>
          </template>
        </custom-table>
      </div>
      <el-form :model="form" ref="form" :rules="rules" label-width="auto">
        <el-form-item :label="$t('components_contract_change_device.shen_qing_miao_shu')" prop="changeDesc">
          <el-input :disabled="model.type === 'watch'" type="textarea" :rows="4" v-model="form.changeDesc" style="width: 636px"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <!-- 选择设备 -->
    <device-select v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onSelectDevice"></device-select>
    <!-- 预览账单 -->
    <preview-bill-dialog v-if="dialogVisible1" :model="dialogModel1"  @close="dialogVisible1 = false"></preview-bill-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import deviceSelect from './children/device_select_dialog.vue';
import previewBillDialog from './children/preview_bill_dialog.vue';

export default {
  props: {
    model: {
      type: Object,
      default() {
        return {
          type: '', // add / edit / watch
          changeId: '' // 新增时为orderId, 编辑查看时为changeId
        };
      }
    }
  },
  components: {
    deviceSelect,
    previewBillDialog
  },
  data() {
    return {
      orgList: [],
      detail: {},
      dataList: [],
      selectDevice: [],
      lastDevice: [],
      lastContract: '',
      dialogVisible: false,
      dialogModel: {},
      dialogVisible1: false,
      dialogModel1: {},
      form: {
        changeOrderId: '',
        orderId: '',
        changeDesc: '',
        changeOrderDevices: []
      },
      bizTypeList: []
    };
  },
  computed: {
    rules() {
      return {
        changeDesc: [{ required: true, message: this.$t('Common.com_required') }, { max: 200, message: this.$t('Common.com_rules_length_max', [200]), }]
      };
    },
    isSubmit: vm => !vm.selectDevice.length,
    orgId() {
      const userInfo = this.$store.state.userInfo;
      return userInfo ? userInfo.rootOrgId : '';
    },
  },
  mounted() {
    this.initDialog();
    this.getDictionary('dms_device_biz_type', (dic) => {
      this.bizTypeList = dic.dms_device_biz_type.map(t => t.value);
    });
  },
  methods: {
    getList: function (list) {
      this.orgList = list;
    },
    // 预览账单
    onPreview: function (row) {
      this.dialogModel1.title = this.$t('components_contract_change_device.yu_lan_zhang_dan');
      this.dialogModel1.type = 'change_device';
      this.dialogModel1.row = Object.assign({}, this.detail, row);
      this.dialogVisible1 = true;
    },
    // 初始化
    initDialog: function () {
      if (this.model.type === 'add') {
        this.form.orderId = this.model.changeId;
        this.getOrderInfo();
        this.getDeviceList();
      }
      if (this.model.type === 'edit') {
        this.form.changeOrderId = this.model.changeId;
        this.getChangeDetail((list) => {
          this.getDeviceList(list);
        });
      }
      if (this.model.type === 'watch') {
        this.form.changeOrderId = this.model.changeId;
        this.getChangeDetail((list) => {
          this.dataList = list;
          this.dataList.forEach((item) => {
            item.isExists = true;
            this.$refs.customTb1.$emit('toggleRowSelection', item, true);
          });
        });
      }
    },
    // 订单信息
    getOrderInfo: function () {
      this.$getJSON(apis.ChangeOrderInfo, {
        orderId: this.model.changeId
      }).then((res) => {
        this.detail = res.data || {};
      });
    },
    // 获取变更详情
    getChangeDetail: function (cb) {
      cb = cb || function () {};
      this.$getJSON(apis.OrderChangeInfo, {
        changeOrderId: this.model.changeId
      }).then((res) => {
        this.detail = res.data || {};
        this.form.orderId = res.data.orderId;
        this.form.changeDesc = res.data.changeDesc;
        cb(res.data.changeDeviceInfos);
      });
    },
    // 合同设备列表
    getDeviceList: function (selectDevice) {
      this.$getJSON(apis.OrderChangeDeviceList, {
        orderId: this.form.orderId,
        showDeviceType: 1,
        bizState: ['21', '22'],
      }).then((res) => {
        const list = res.data;
        list.forEach((item) => {
          item.newBodyNum = '';
          item.newDeviceId = '';
          item.deviceBackOrgId = '';
          item.deviceBackOrgName = '';
        });
        this.dataList = list.filter(t => t.oldAfterServiceId === this.orgId);
        if (selectDevice) {
          this.dataList.forEach((item) => {
            const row = selectDevice.find(t => t.orderDeviceId === item.orderDeviceId);
            if (row) {
              item.newBodyNum = row.newBodyNum;
              item.newDeviceId = row.newDeviceId;
              item.deviceBackOrgId = row.deviceBackOrgId;
              item.deviceBackOrgName = row.deviceBackOrgName;
              this.$refs.customTb1.$emit('toggleRowSelection', item, true);
            }
          });
        }
        // 在续租合同时（续租设备处理）
        const renewalDeviceList = list.filter(t => !!t.lastOrderDeviceId);
        if (renewalDeviceList.length > 0) {
          // 未到期(原合同)
          const list1 = renewalDeviceList.filter(t => t.lastBizState < 43);
          if (list1.length > 0) {
            this.lastDevice = list1.map(f => f.bodyNum);
            this.lastContract = list1[0]['lastContractNo'];
            this.dataList.forEach((item) => {
              item.isExists = this.lastDevice.includes(item.bodyNum);
            });
          }
        }


      });
    },
    // 选择设备弹窗
    onDeviceDialog: function (row) {
      // let isOwn = false;
      // if (row.rentalStartTime && row.endRentDate) {
      // 不一定要启租 不启租是其他类型的也可以
      // var a = this.$moment.utc(row.rentalStartTime || new Date());
      // var b = this.$moment.utc();
      // isOwn = b.diff(a, 'months') < 6 || row.deviceBizType !== 'A';
      // const bizTypeList = this.bizTypeList.filter(t => (isOwn ? t >= row.deviceBizType : t > row.deviceBizType));
      // if (row.deviceBizType === 'F') {
      //   bizTypeList.push('C');
      //   bizTypeList.push('D');
      // }
      // if (row.deviceBizType === 'C' || row.deviceBizType === 'D') {
      //   bizTypeList.push('C');
      //   // 设备类型C 原设备类型D 移除 F
      //   // bizTypeList = bizTypeList.filter(t => t !== 'F');
      // }
      // // }
      // row.bizTypeList = bizTypeList;
      this.dialogModel.title = this.$t('components_contract_change_device.xuan_ze_she_bei');
      this.dialogModel.row = row;
      this.dialogVisible = true;
    },
    // 选择设备保存
    onSelectDevice: function (row) {
      this.dialogModel.row.newBodyNum = row.bodyNum;
      this.dialogModel.row.newDeviceId = row.deviceId;
    },
    // 选择退回地址
    onSelectBackOrg: function (data, row) {
      row.deviceBackOrgName = data.partnerName;
    },
    // 确认保存
    onConfirm: function (approve) {
      if (this.model.type === 'watch') {
        this.$emit('close');
        return;
      }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (!this.selectDevice.length) {
          this.$message.error(this.$t('components_contract_change_device.qing_xuan_ze_she_bei'));
          return;
        }
        const hasEmpty = this.selectDevice.find(t => !t.newBodyNum || !t.deviceBackOrgId);
        if (hasEmpty) {
          this.$message.error(this.$t('components_contract_change_device.qxzxjshhsbthdd'));
          return;
        }
        this.form.isStartApprove = approve || 0;
        this.form.changeOrderDevices = this.selectDevice;
        this.$postJSON(apis.OrderDeviceSave, this.form).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success'
          });
          this.$emit('success');
        });
      });
    }
  }
};
</script>

<style lang="scss"></style>
